import { useEffect, useRef } from "react";

// One publication, many cards (feed, profile, theater, fullscreen viewer, snapshot cache):
// every reaction / comment change is broadcast so all of them update instantly.
const EV = "yalola:post_patch";

// patch: { my_reaction?, reactions?, comment_delta?, resume_t?, my_repost?, repost_count? }
export const emitPostPatch = (id, patch) => {
  if (!id || !patch) return;
  window.dispatchEvent(new CustomEvent(EV, { detail: { id, patch } }));
};

export const applyPostPatch = (post, patch) => {
  const next = { ...post };
  if ("my_reaction" in patch) next.my_reaction = patch.my_reaction;
  if (patch.reactions) next.reactions = patch.reactions;
  if (typeof patch.comment_delta === "number") next.comment_count = Math.max(0, (post.comment_count || 0) + patch.comment_delta);
  if (typeof patch.resume_t === "number") next.resume_t = patch.resume_t;
  if ("my_repost" in patch) next.my_repost = patch.my_repost;
  if (typeof patch.repost_count === "number") next.repost_count = patch.repost_count;
  return next;
};

export const patchPostList = (list, id, patch) =>
  Array.isArray(list) && list.some((p) => p?.id === id) ? list.map((p) => (p?.id === id ? applyPostPatch(p, patch) : p)) : list;

export const onPostPatch = (fn) => {
  const h = (e) => { const d = e?.detail; if (d?.id) fn(d.id, d.patch); };
  window.addEventListener(EV, h);
  return () => window.removeEventListener(EV, h);
};

// Card-level: react to patches for ONE post id.
export function usePostPatch(id, handler) {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => onPostPatch((pid, patch) => { if (pid === id) ref.current?.(patch); }), [id]);
}

// Page-level: keep a posts array (useState setter) in sync.
export function usePostListSync(setPosts) {
  useEffect(() => onPostPatch((id, patch) => setPosts((list) => patchPostList(list, id, patch))), [setPosts]);
}
